import { render } from "./Resenas.vue?vue&type=template&id=007342e5"
const script = {}
script.render = render

export default script